import { pushPreSentryMetric } from 'core/utils/perf.js'
import { getClient, isInitialized, setMeasurement, startInactiveSpan, startSpan } from 'src/common/sentry-client'

export function usePerfStep(name, fn, attributes = {}) {
  return startSpan(
    {
      name,
      op: 'performance',
      attributes,
    },
    fn,
  )
}

export function usePerfStepManual(name, attributes = {}) {
  const start = Date.now()

  const span = startInactiveSpan({
    name,
    op: 'performance',
    ...attributes,
  })

  let finished = false

  function finish(extra = {}) {
    if (finished) {
      return
    }
    finished = true
    if (span) {
      Object.entries(extra).forEach(([key, val]) => {
        span.setAttribute(key, val)
      })
      span.setAttribute('perf.duration', Date.now() - start)
      span.end()
    }
  }

  return { finish, span }
}

function sentryReady() {
  return isInitialized() || !!getClient()
}

export function waitForSentryReady(interval = 500, timeout = 5000) {
  return new Promise((resolve) => {
    const start = Date.now()

    const timer = setInterval(() => {
      if (sentryReady()) {
        clearInterval(timer)
        resolve(true)
      } else if (Date.now() - start > timeout) {
        clearInterval(timer)
      }
    }, interval)
  })
}

export function flushPreSentryMetrics() {
  const buf = Array.isArray(window.SENTRY_M) ? window.SENTRY_M : []
  buf.forEach(({ name, elapsed, unit }) => {
    if (localStorage.getItem('debug_perf')) {
      // eslint-disable-next-line no-console
      console.log(name, elapsed, unit)
    }
    if (typeof name === 'string' && typeof elapsed === 'number') {
      setMeasurement(name, elapsed, unit)
    }
  })
  if (localStorage.getItem('debug_perf')) {
    return
  }
  delete window.SENTRY_M
}

export function reachCheckpoint(name) {
  const startTime = window.appStartTime || performance.now()
  const now = performance.now()
  const elapsed = Math.round(now - startTime)

  if (sentryReady()) {
    setMeasurement(name, elapsed, 'millisecond')
  } else {
    pushPreSentryMetric(name, elapsed, 'millisecond')
  }
}
